import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Content, Section, TabMenu, TextDiv } from "../../styles/Common";
import { styled } from "styled-components";
import FaqList from "../../components/service/FaqList";
import { getToken } from "../../components/hooks/authFunc";
import { useDispatch, useSelector } from "react-redux";
import { serviceActions } from "../../store/slices/serviceSlice";
import OnlyHeaderLayout from "../../components/layout/OnlyHeaderLayout";

const Faq = () => {
  const accessToken = getToken();
  const dispatch = useDispatch();
  const [currentTab, clickTab] = useState(0);
  const [search, setSearch] = useState("0");
  const data = useSelector((state) => state.service.faqList);
  const menuArr = [
    { name: "전체", search: "0", content: <FaqList data={data} /> },
    { name: "회원가입/탈퇴", search: "1", content: <FaqList data={data} /> },
    { name: "포인트", search: "2", content: <FaqList data={data} /> },
    { name: "기타", search: "6", content: <FaqList data={data} /> },
  ];

  const getData = () => {
    const params = {
      search: search,
    };
    dispatch(serviceActions.fetchFaqList({ params, accessToken }));
  };

  useEffect(() => {
    getData();
  }, [currentTab]);

  const selectMenuHandler = (index, searchValue) => {
    // parameter로 현재 선택한 인덱스 값을 전달해야 하며, 이벤트 객체(event)는 쓰지 않는다
    // 해당 함수가 실행되면 현재 선택된 Tab Menu 가 갱신.
    setSearch(searchValue);
    clickTab(index);
  };

  return (
    <OnlyHeaderLayout title="FAQ">
      <Section className="nonePaddingTop">
        <Content>
          <FaqTabMenu>
            {menuArr.map((el, index) => (
              <li
                key={index}
                className={index === currentTab ? "pointer focused" : "pointer"}
                onClick={() => selectMenuHandler(index, el.search)}
              >
                {el.name}
              </li>
            ))}
          </FaqTabMenu>
          {data && data.count > 0 && <Desc>{menuArr[currentTab].content}</Desc>}
        </Content>
      </Section>
    </OnlyHeaderLayout>
  );
};

export default Faq;
const FaqTabMenu = styled(TabMenu)`
  li {
    width: 22%;
  }
  :nth-of-type(2) {
    width: 32%;
  }
`;
const Desc = styled.div`
  margin-top: 2rem;
`;
